import checkboxWhite from "../../../static/assets/checkbox_white.png";
import crossWhite from "../../../static/assets/cross_white.png";
import React from 'react'

const pricingFieldDescriptions = {
    trackedProfiles: "test"
}

const PricingPlans = [
    {
        planName: "Our Plans",
        planPrice: "10",
        planInfo: "you save 20% if you go yearly",
        trackedProfiles: "TRACKED PROFILES / mo",
        businessAccounts: "INSTAGRAM ACCOUNTS",
        profileRefreshes: "DAILY REFRESHES",
        standardIntegrations: "INTEGRATIONS",
        visible: false,
        col: false,
        reels: "REELS TRACKING",
        storyDetection: "STORY TRACKING",
        brandsInstagramAnalysis: "FOLLOWERS' ANALYSIS",
        customIntegrations: "CUSTOM DEV",
        successManager: "CUSTOMER SUCCESS MANAGER",
        hideMobile: true
    },
    /*    {
          planName: "Free",
          planPrice: "10",
          planInfo: "you save 20% if you go yearly",
          trackedProfiles: "50",
          businessAccounts: "1",
          profileRefreshes: "50",
          standardIntegrations: "yes",
          visible: false,
          col: true,
        },*/
    {
        planName: "Lite",
        planPrice: "79",
        planInfo: "you save 20% if you go yearly",
        trackedProfiles: "400",
        businessAccounts: "1",
        profileRefreshes: "200",
        standardIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
        visible: true,
        col: true,
        reels:  <img alt="tick mark" src={checkboxWhite} width="16" />,
        storyDetection:  <img alt="tick mark" src={checkboxWhite} width="16" />,
        brandsInstagramAnalysis: <img alt="tick mark" src={crossWhite} width="16" />,
        customIntegrations: <img alt="cross mark" src={crossWhite} width="16" />,
        successManager: <img alt="cross mark" src={crossWhite} width="16" />
    },
    {
        planName: "Basic",
        planPrice: "249",
        planInfo: "you save 20% if you go yearly",
        trackedProfiles: "3000",
        businessAccounts: "2",
        profileRefreshes: "3000",
        standardIntegrations:  <img alt="tick mark" src={checkboxWhite} width="16" />,
        visible: true,
        col: true,
        reels:  <img src={checkboxWhite} width="16"  alt={"tick mark"}/>,
        storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
        brandsInstagramAnalysis: <img alt="cross mark" src={crossWhite} width="16" />,
        customIntegrations: <img alt="cross mark" src={crossWhite} width="16" />,
        successManager: <img alt="cross mark" src={crossWhite} width="16" />
    },
    {
        planName: "Business",
        planPrice: "799",
        planInfo: "you save 20% if you go yearly",
        trackedProfiles: "12000",
        businessAccounts: "5",
        profileRefreshes: "12000",
        standardIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
        visible: true,
        col: true,
        reels: <img alt="tick mark" src={checkboxWhite} width="16" />,
        storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
        brandsInstagramAnalysis: <img alt="tick mark" src={checkboxWhite} width="16" />,
        customIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
        successManager: <img alt="cross mark" src={crossWhite} width="16" />
    },
    {
        planName: "Enterprise",
        planPrice: "999",
        planInfo: "you save 20% if you go yearly",
        trackedProfiles: "Unlimited",
        businessAccounts: "5",
        profileRefreshes: "Unlimited",
        standardIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
        visible: true,
        col: true,
        reels: <img alt="tick mark" src={checkboxWhite} width="16" />,
        storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
        brandsInstagramAnalysis: <img alt="tick mark" src={checkboxWhite} width="16" />,
        customIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
        successManager: <img alt="tick mark" src={checkboxWhite} width="16" />
    },
]

const PricingData = {
    fieldsDescription: pricingFieldDescriptions,
    plans: PricingPlans
}

/*  const pricingDataMobile = [
/!*    {
      planName: "Free",
      planPrice: "10",
      planInfo: "you save 20% if you go yearly",
      trackedProfiles: "50",
      businessAccounts: "1",
      profileRefreshes: "50",
      standardIntegrations: "yes",
      visible: false,
      col: true,
    },*!/
    {
      planName: "Lite",
      planPrice: "79",
      planInfo: "you save 20% if you go yearly",
      trackedProfiles: "400",
      businessAccounts: "1",
      profileRefreshes: "200",
      standardIntegrations: "yes",
      visible: true,
      col: true,
      reels: <img alt="tick mark" src={checkboxWhite} width="16" />,
      storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
      brandsInstagramAnalysis: <img alt="tick mark" src={crossWhite} width="16" />,
      customIntegrations: <img alt="cross mark" src={crossWhite} width="16" />,
      successManager: <img alt="cross mark" src={crossWhite} width="16" />
    },
    {
      planName: "Basic",
      planPrice: "249",
      planInfo: "you save 20% if you go yearly",
      trackedProfiles: "3000",
      businessAccounts: "2",
      profileRefreshes: "3000",
      standardIntegrations: "yes",
      visible: true,
      col: true,
      reels: <img alt="tick mark" src={checkboxWhite} width="16" />,
      storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
      brandsInstagramAnalysis: <img alt="cross mark" src={crossWhite} width="16" />,
      customIntegrations: <img alt="cross mark" src={crossWhite} width="16" />,
      successManager: <img alt="cross mark" src={crossWhite} width="16" />
    },
    {
      planName: "Business",
      planPrice: "799",
      planInfo: "you save 20% if you go yearly",
      trackedProfiles: "12000",
      businessAccounts: "5",
      profileRefreshes: "12000",
      standardIntegrations: "yes",
      visible: true,
      col: true,
      reels: <img alt="tick mark" src={checkboxWhite} width="16" />,
      storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
      brandsInstagramAnalysis: <img alt="tick mark" src={checkboxWhite} width="16" />,
      customIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
      successManager: <img alt="cross mark" src={crossWhite} width="16" />
    },
    {
      planName: "Enterprise",
      planPrice: "999",
      planInfo: "you save 20% if you go yearly",
      trackedProfiles: "Unlimited",
      businessAccounts: "5",
      profileRefreshes: "Unlimited",
      standardIntegrations: "yes",
      visible: true,
      col: true,
      reels: <img alt="tick mark" src={checkboxWhite} width="16" />,
      storyDetection: <img alt="tick mark" src={checkboxWhite} width="16" />,
      brandsInstagramAnalysis: <img alt="tick mark" src={checkboxWhite} width="16" />,
      customIntegrations: <img alt="tick mark" src={checkboxWhite} width="16" />,
      successManager: <img alt="tick mark" src={checkboxWhite} width="16" />
    },
  ]*/

export default PricingData